/* istanbul ignore file */
export default class ApiError extends Error {
    public code: string;
    constructor(code: string) {
        super(code);

        this.code = code;
        Object.setPrototypeOf(this, ApiError.prototype);
    }
}
